"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OvertimeSection = void 0;
const ui_1 = require("@app/component/ui");
const Dropdown_1 = require("@app/component/ui/dropdown/Dropdown");
const dropdown_input_1 = require("@app/component/ui/forms/dropdown-input/dropdown-input");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const filtered_content_for_organization_1 = require("@app/util/filtered-content-for-organization");
const use_debounce_1 = require("@app/util/forms/use-debounce");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const form_grid_layout_1 = require("../../../ui/forms/form-grid-layout");
const shift_modal_section_1 = require("../components/shift-modal-section");
const shift_context_1 = require("../shift-context");
const getOvertimeErrors = (tag, overtimeStart, overtimeDuration, period) => {
    if (!(0, util_1.isValue)(overtimeStart)) {
        return undefined;
    }
    if (!(0, util_1.isValue)(overtimeDuration)) {
        return undefined;
    }
    if (overtimeStart < 0) {
        return {
            hasError: true,
            errorMessage: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.shift.overTimeOutsideShift')),
        };
    }
    const _endMinutes = (0, moment_1.default)(period.end).get('hours') * 60 + (0, moment_1.default)(period.end).get('minutes');
    const _startMinutes = (0, moment_1.default)(period.start).get('hours') * 60 + (0, moment_1.default)(period.start).get('minutes');
    const dayOffset = _endMinutes <= _startMinutes ? 1440 : 0;
    const periodEndMinutes = dayOffset + _endMinutes - _startMinutes;
    if ((tag === 'end' || tag === undefined) &&
        overtimeStart + overtimeDuration > periodEndMinutes) {
        return {
            hasError: true,
            errorMessage: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.shift.overTimeOutsideShift')),
        };
    }
    if ((tag === 'start' || tag === undefined) && overtimeStart > periodEndMinutes) {
        return {
            hasError: true,
            errorMessage: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.shift.overTimeOutsideShift')),
        };
    }
};
const OvertimeSection = () => {
    const { formControl, setValue, disabledEditation } = (0, shift_context_1.useShift)();
    const overtime = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'overTime' });
    const [overtimeDurationType, setOvertimeDurationType] = react_1.default.useState(!(0, util_1.isValue)(overtime?.start) && !(0, util_1.isValue)(overtime?.duration) ? 'full' : 'partial');
    const period = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period' });
    const unpaidOpts = [
        // "proplatit" (default) -> valUnpaid: false, valPaidTOIL: false
        Object.freeze({
            value: 'opt2',
            label: (0, util_1.t)('OVERTIME_UNPAID_FALSE'),
            valUnpaid: false,
            valPaidTOIL: false,
        }),
        // prevest -> valUnpaid: true, valPaidTOIL: false
        Object.freeze({
            value: 'opt1',
            label: (0, util_1.t)('OVERTIME_UNPAID_TRUE'),
            valUnpaid: true,
            valPaidTOIL: false,
        }),
        // "proplatit prevedeny" -> valUnpaid: false, valPaidTOIL: true
        (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('shift_overtime_unpaid_toil', Object.freeze({
            value: 'opt3',
            label: (0, util_1.t)('OVERTIME_UNPAID_TOIL'),
            valUnpaid: false,
            valPaidTOIL: true,
        }), undefined),
    ].filter(util_1.isValue);
    const overtimeOrderedOptions = [
        // narizeny (default)
        { value: true, label: (0, util_1.t)('OVERTIME_ORDERED_TRUE') },
        // domluveny
        { value: false, label: (0, util_1.t)('OVERTIME_ORDERED_FALSE') },
    ];
    const overtimeDurationTypeOptions = [
        {
            label: (0, util_1.t)('OVERTIME_WHOLE_SHIFT'),
            value: 'full',
        },
        {
            label: (0, util_1.t)('OVERTIME_PART_OF_SHIFT'),
            value: 'partial',
        },
    ];
    const { value: overtimeStartValueDebounced, onChange: overtimeStartOnChangeDebounced, } = (0, use_debounce_1.useDebounce)({
        value: (0, maybe_unwrap_1.unwrapMaybe)(overtime?.start),
        onChange: (minutes) => {
            setValue('overTime.start', minutes);
        },
        ms: 750,
    });
    const { value: overtimeDurationValueDebounced, onChange: overtimeDurationOnChangeDebounced, } = (0, use_debounce_1.useDebounce)({
        value: (0, maybe_unwrap_1.unwrapMaybe)(overtime?.duration),
        onChange: (minutes) => {
            setValue('overTime.duration', minutes);
        },
        ms: 750,
    });
    return (react_1.default.createElement(shift_modal_section_1.ShiftModalSection, { id: 'overtime' },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement(ui_1.RadioGroup, { options: overtimeDurationTypeOptions, value: overtimeDurationType, disabled: (0, util_1.isDefined)(disabledEditation), onChange: (v) => {
                    if (typeof v !== 'string') {
                        throw new Error('incorrect overtime type');
                    }
                    if (v !== 'full' && v !== 'partial') {
                        throw new Error('incorrect overtime type');
                    }
                    setOvertimeDurationType(v);
                    if (v === 'full') {
                        setValue('overTime.start', null);
                        setValue('overTime.duration', null);
                        return;
                    }
                    setValue('overTime.start', 0);
                    setValue('overTime.duration', 60);
                } }),
            react_1.default.createElement("div", null),
            overtimeDurationType === 'partial' && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui_1.Input, { type: 'time', size: 'full-width', label: (0, util_1.t)('OVERTIME_START'), disabled: (0, util_1.isDefined)(disabledEditation), value: (0, moment_1.default)(period.start)
                        .add(overtimeStartValueDebounced ?? 0, 'minutes')
                        .format('HH:mm'), onChange: (val) => {
                        const s = (0, moment_1.default)(period.start).format('YYYY-MM-DD') + ' ' + val;
                        let startMoment = (0, moment_1.default)(s, 'YYYY-MM-DD HH:mm');
                        if (startMoment.isBefore(period.start))
                            startMoment = startMoment.add(1, 'day');
                        overtimeStartOnChangeDebounced(startMoment
                            .startOf('minute')
                            .diff(period.start.startOf('minute'), 'minutes'));
                    }, ...getOvertimeErrors('start', overtime?.start, overtime?.duration, period) }),
                react_1.default.createElement(ui_1.Input, { type: 'time', size: 'full-width', label: (0, util_1.t)('OVERTIME_END'), disabled: (0, util_1.isDefined)(disabledEditation), value: (0, moment_1.default)(period.start)
                        .add(overtimeStartValueDebounced ?? 0, 'minutes')
                        .add(overtimeDurationValueDebounced ?? 0, 'minutes')
                        .format('HH:mm'), onChange: (val) => {
                        const s = (0, moment_1.default)(period.start).format('YYYY-MM-DD') + ' ' + val;
                        const endMoment = (0, moment_1.default)(s, 'YYYY-MM-DD HH:mm').startOf('minute');
                        const startMoment = (0, moment_1.default)(period.start)
                            .startOf('minute')
                            .add(overtime?.start ?? 0, 'minutes');
                        let dur = endMoment.diff(startMoment, 'minutes');
                        if (dur < 0)
                            dur += 1440;
                        overtimeDurationOnChangeDebounced(dur);
                    }, ...getOvertimeErrors('end', overtime?.start, overtime?.duration, period) }))),
            react_1.default.createElement(Dropdown_1.Dropdown, { label: (0, util_1.t)('OVERTIME_UNPAID'), singleSelect: true, size: 'full-width', options: unpaidOpts, disableSort: true, type: Dropdown_1.Dropdown.TYPES.VARIABLE, style: Dropdown_1.Dropdown.STYLES.LIGHT, disabled: (0, util_1.isDefined)(disabledEditation), value: unpaidOpts.find((o) => o.valUnpaid === overtime?.unpaid &&
                    o.valPaidTOIL === overtime?.paidTOIL), onChange: (v) => {
                    switch (v.value) {
                        case 'opt1': {
                            setValue('overTime.unpaid', true);
                            setValue('overTime.paidTOIL', false);
                            return;
                        }
                        case 'opt2': {
                            setValue('overTime.unpaid', false);
                            setValue('overTime.paidTOIL', false);
                            const overTimeIsOrdered = (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('overtime_unpaid_false_should_be_ordered', false, {});
                            setValue('overTime.ordered', overTimeIsOrdered);
                            return;
                        }
                        case 'opt3': {
                            setValue('overTime.unpaid', false);
                            setValue('overTime.paidTOIL', true);
                            return;
                        }
                        default:
                            throw new Error('incorrect unpaid option');
                    }
                } }),
            react_1.default.createElement(dropdown_input_1.DropdownInput, { label: (0, util_1.t)('OVERTIME_ORDERED'), options: overtimeOrderedOptions, control: formControl, name: 'overTime.ordered', disabled: (0, util_1.isDefined)(disabledEditation) }))));
};
exports.OvertimeSection = OvertimeSection;
